import './Min.css';
export var minValue = '_1snrxjl0-2-0-1';